import React from "react";
import Footer from "../components/footer";

const Terms = () => {
  const terms = [
    {
      id: 1.1,
      title: "Updates and Modifications",
      description: [
        "The Company reserves the right to modify these Terms at any time. We will notify you of significant changes by updating the 'Last Updated' date at the start of these Terms and, when feasible, providing notice through the Site. Continued use of the Site after such changes constitutes your acceptance of the new Terms. It is your responsibility to review these Terms periodically.",
      ],
    },
    {
      id: 1.2,
      title: "Data Privacy",
      description: [
        "Our handling of your personal information is detailed in our Privacy Policy. By agreeing to these Terms, you consent to the collection, use, storage, and disclosure of your information as outlined in the Privacy Policy.",
      ],
      privacyPolicyLink: "[https://www.the-catalyst.xyz/privacy]",
    },
    {
      id: 1.3,
      title: "Non-Custodial Nature of Services",
      description: [
        "The Company does not hold, control, or manage your digital wallets, NFTs, or any digital assets therein. We facilitate transactions and interactions through the Site without serving as intermediaries or custodians. The technical and contractual management of your digital assets relies solely on smart contracts and your independent actions.",
      ],
    },
    {
      id: 1.4,
      title: "User Eligibility and Representations",
      description: [
        "You affirm that you are of legal age to form a binding contract in your jurisdiction and at least 16 years old. Users under 18 must use the Site under the supervision and consent of a guardian. You warrant that you have the authority to bind yourself or any entity you represent to these Terms.",
        " If you are using the Site on behalf of an entity, you confirm that you are authorized to act on behalf of that entity and that you bind both yourself and the entity to these Terms. This includes authorizing transactions and interactions initiated via your digital wallet.",
      ],
    },
    {
      id: 1.5,
      title: "Legal and Tax Compliance",
      description: [
        "You are solely responsible for understanding and complying with all applicable laws related to your use of the Site, including tax obligations. The Company does not provide legal, tax, or financial advice and is not responsible for tax calculations or reports related to your activities on the Site.",
      ],
    },
  ];
  const services = [
    {
      id: 2.1,
      title: "Wallet Connection & Security",
      description: [
        "To access and fully engage with our Services, it is essential that you connect a third-party digital wallet that is compatible with the Songbird or Flare networks. Supported wallet extensions such as MetaMask, Wallet Connect, and others are necessary for this integration. By connecting your wallet to the Site, you confirm that you are the legitimate owner of the wallet and authorized to conduct transactions. Ownership must be authenticated cryptographically via your selected wallet extension before any transactions can occur on the Site. This process ensures secure and authorized interactions with the blockchain, with the Site serving merely as an interface without any control or management over your digital assets or wallet operations. Remember, while using your wallet in conjunction with our Services, you are agreeing to adhere to the terms and conditions set by your wallet provider.The digital assets within your wallet remain your property; the Company does not assume ownership, nor does it have the capability or authority to manage, modify, or directly interact with your wallet's content.",
        "The security and management of your digital wallet rest entirely with you. You are responsible for implementing and maintaining robust security measures to safeguard your wallet's integrity. This includes protecting sensitive details such as your private keys, passphrase, and any other critical access information. Preventing unauthorized access and resisting potential scams that threaten wallet security are critical. In the event of a security breach or unauthorized use of your wallet, it is imperative that you notify us immediately to mitigate any potential damage. The Company disclaims all liability for losses that may arise from such incidents and will not be responsible for securing your wallet. Additionally, you are liable for any repercussions, whether to the Company, other Users, or external parties, due to negligence or inadequate security practices related to your wallet. For detailed guidance on setting up and securing your wallet, please refer to our help section.",
      ],
    },
    {
      id: 2.2,
      title: "Legal Compliance",
      description: [
        "You are obligated to use our Services only for purposes that are legal, proper, and fully compliant with these Terms, along with all applicable local, state, federal, and international laws. You agree not to send, mint, publish, upload, distribute, or disseminate any content that is unlawful, infringing, defamatory, harassing, abusive, fraudulent, obscene, or otherwise objectionable. Furthermore, you must not distribute harmful or deceptive software such as viruses or Trojan horses; impersonate any person or entity, or falsely state your affiliation with a person or entity; defraud, deceive or mislead the Company, other Users, or any other entities; violate the intellectual, property, privacy, or other rights of others; engage in or promote illegal activities like terrorism, tax evasion, or money laundering. You must not interfere with other users’ access to or enjoyment of the Services; defame, abuse, harass, or stalk other Users; or harvest or collect personal information about Users without their consent. Additionally, you are prohibited from using automated means to access the Services for any purpose without our express written permission; nor may you engage in unauthorized commercial activities, modify, adapt, translate, or reverse engineer any portion of the Services. You are also responsible for not removing any copyright or trademark notices from content accessed through the Services and for not using any data mining, robots, or similar data gathering and extraction tools to collect information about users without authorization. Your commitment to these terms ensures a secure, legal, and respectful environment for all users.",
      ],
    },
    {
      id: 2.3,
      title: "User Licensing Agreement",
      description: [
        "You are granted a limited, revocable, non-exclusive, non-transferable and personal license to access and use the Services, provided your use complies with these Terms. This license does not include any right for resale or commercial use of the Services or their contents, nor does it permit any collection and use of any product listings, descriptions, or prices; any derivative use of the Services or their contents; any downloading, copying, or other use of account information for the benefit of any third party; or any use of data mining, robots, or similar data gathering and extraction tools.",
      ],
    },
    {
      id: 2.4,
      title: "Account Management and Security",
      description: [
        "The security of your account and its associated digital wallet rests with you. Unauthorized access or use, loss, or theft should be reported to the Company immediately through our designated channels. You are responsible for maintaining the confidentiality of your account information, and for any and all activity that occurs under your account due to your failing to keep this information secure and confidential.",
      ],
    },
    {
      id: 2.5,
      title: "Third-Party Services and Links",
      description: [
        "The Services may integrate, be integrated into, or be provided in connection with third-party services and content. You agree that the Company is not responsible for any third-party services and that the use of any such services will be at your own risk. Interactions with these services are subject to terms set by the third-party providers.",
      ],
    },
    {
      id: 2.6,
      title: "Ownership and Intellectual Property of the Service",
      description: [
        "The Company retains exclusive rights, title, and interest in the Site and all elements of the Services, including but not limited to designs, graphics, software, systems, methods, information and logos, referred to collectively as “Company Assets”. These materials are protected under copyright, patent, trademark, trade dress, and other relevant intellectual property laws. Unauthorized use of the Company’s trademarks, logos, and other graphical elements featured in our Services is strictly prohibited without our prior written consent. This includes any attempt to copy, imitate, or otherwise exploit the Company Assets. You are granted no ownership or other rights in the content, code, data, or any materials accessed through the Services beyond what is explicitly stated in these Terms.",
        "All proprietary rights in the Services are owned by the Company or its licensors. Usage of the Services does not imply any transfer of these rights to you, and all rights not explicitly granted are reserved by the Company. The use of third-party trademarks and copyrighted content associated with the Services is bound by the respective owners’ terms and must not be copied or used without express permission from these rights holders. Mentioning or displaying third-party trademarks or content within the Services does not suggest endorsement or affiliation by the Company",
      ],
    },
    {
      id: 2.7,
      title: "Content Modification and Removal",
      description: [
        "The Company reserves the right to modify, suspend, or discontinue the Services (or any part or content thereof) at any time with or without notice to you. The Company will not be liable to you or to any third party should it exercise such rights.",
      ],
    },
    {
      id: 2.8,
      title: "Prohibited Actions and Content",
      description: [
        "You agree not to engage in unacceptable use of the Services, which includes, without limitation, use of the Services to disseminate or transmit illegal material, or malicious content like malware or spyware. You must not use the services to harass or harm others, infringe on others’ intellectual property rights, or engage in activity that risks the integrity of the Service.",
      ],
    },
  ];

  const protocol = [
    {
      id: 3.1,
      title: "Transaction Processing on Songbird and Flare Networks",
      description: [
        "The Catalyst Protocol comprises a set of interrelated, non-custodial smart contracts deployed to the Songbird and Flare blockchains. These smart contracts store information and perform functions related to the minting, buying, and selling of NFTs within The Catalyst. Unlike traditional custodial services, The Catalyst does not take custody of any digital assets. Transactions initiated through the platform are publicly broadcasted by the user’s digital wallet provider and processed by the blockchain. Users understand and agree that they are responsible for all actions performed by their digital wallets, including minting, collecting, and transferring NFTs.",
      ],
    },
    {
      id: 3.2,
      title: "Blockchain Risks and Security Considerations",
      description: [
        "Users should be aware that blockchain technology is experimental and may be subject to various risks, including but not limited to bugs, vulnerabilities, and potential third-party attacks such as phishing, brute-forcing, or impersonation. The Catalyst cannot anticipate or control these risks and disclaims all liability for any losses or damages that users may incur as a result. Furthermore, regulatory uncertainties surrounding digital assets and blockchain technology may adversely impact users' ability to use and enjoy the platform. Users accept full responsibility for managing these risks and are advised to take appropriate precautions to protect their digital assets.",
      ],
    },
    {
      id: 3.3,
      title: "Fees for Blockchain Transactions",
      description: [
        "Transactions on the Songbird and Flare blockchains require the payment of a transaction fee, commonly known as a 'Gas Fee,' to network validators. The amount of the Gas Fee can vary significantly depending on network congestion and other factors beyond The Catalyst's control. Users acknowledge that these fees are necessary for the execution of blockchain transactions and agree to cover all costs associated with their transactions, including any unexpected fluctuations in Gas Fees. Under no circumstances will a transaction be invalidated, revoked, or otherwise unenforceable due to dissatisfaction with the Gas Fee amount.",
      ],
    },
    {
      id: 3.4,
      title: "Platform Limitations and Blockchain Control",
      description: [
        "The Catalyst is a non-custodial platform and does not control the Songbird and Flare blockchains or any other public blockchain. This means that once a transaction is confirmed on the blockchain, it cannot be reversed or modified by The Catalyst. Users interact with experimental technologies, including blockchain, smart contracts, and NFTs, all of which carry inherent risks. The platform assumes no liability for losses or damages resulting from blockchain technology's inherent vulnerabilities, including but not limited to forks, bugs, and security exploits. Users are encouraged to remain informed about blockchain developments and manage their digital assets with caution.",
      ],
    },
    {
      id: 3.5,
      title: "Prohibition of Illegal Activities",
      description: [
        "Users are prohibited from engaging in any activities on the platform that are illegal or violate these Terms of Service. This includes, but is not limited to, attempts to exploit the platform’s smart contracts, using the platform for money laundering or financing terrorism, or engaging in any activities that would harm the integrity of the platform or the security of other users. The Catalyst reserves the right to restrict access to the platform and take appropriate action, including reporting to law enforcement, if any unlawful use is detected.",
      ],
    },
    {
      id: 3.6,
      title: "User Consent to Smart Contract Operations",
      description: [
        "By using The Catalyst, users agree and consent to the operation of the platform’s smart contracts, which automate the minting, transferring, and selling of NFTs. Users understand that these smart contracts execute transactions based on their inputs, and once a transaction is initiated, it cannot be altered or reversed. Users are responsible for reviewing and approving each transaction, including all associated fees and details, before execution. By interacting with the smart contracts, users consent to the automated processing of their transactions and are bound by the outcomes of these interactions.",
      ],
    },
    {
      id: 3.7,
      title: "Platform Interaction and Permissions with Smart Contracts",
      description: [
        "The Catalyst deploys and maintains the smart contracts necessary for the platform’s operations but does not have the ability to control or interfere with user transactions. The platform’s role is limited to ensuring the proper functioning of these contracts and making them available for public use. Users acknowledge that they have the opportunity to review and audit the platform’s smart contracts and are responsible for understanding how these contracts operate. The Catalyst reserves the right to maintain, update, or modify the smart contracts, but will not interfere with user transactions without explicit on-chain consent.",
      ],
    },
    {
      id: 3.8,
      title: "User Responsibility and Reliance on Information",
      description: [
        "Users of The Catalyst represent that they are knowledgeable and experienced in blockchain technology and digital assets. They acknowledge that they have conducted their own thorough investigation and analysis of the platform and its smart contracts. Users agree that they have not relied on any information, statement, or representation made by The Catalyst or its representatives in deciding to use the platform. All transactions are executed at the user's own risk, and users are solely responsible for assessing the risks and potential outcomes before engaging with the platform.",
      ],
    },
  ];

  const fee = [
    {
      id: "4.1",
      title: "Platform Fee Structure for Transactions",
      description: [
        "The Catalyst implements a structured fee system to facilitate transactions involving NFTs. The following fees, commissions, and royalties apply to all transactions conducted on the platform:",
      ],
      fees: [
        {
          title: "Primary Sale Fee",
          details:
            "A 15% commission is applied to the sale of any newly minted NFT on its first sale, paid by the seller.",
        },
        {
          title: "Transaction Service Fee",
          details:
            "All transactions on The Catalyst incur a 5% service fee paid by the buyer. This fee applies to both primary and secondary sales and covers platform operational costs, including security, server maintenance, and user support. Users must ensure they have sufficient funds to cover this fee in addition to the NFT sale price at the time of purchase.",
        },
        {
          title: "Creator Royalties",
          details:
            "A standard 5% royalty is automatically applied to all secondary market transactions and is distributed to the original creator of the NFT. This royalty is intended to ensure that creators are compensated for their ongoing contributions and the continued circulation of their work. Royalties are embedded within the NFT smart contract, meaning that any sale on the platform or via integrated third-party Sites will trigger an automatic royalty payment to the creator’s designated wallet.",
        },
        {
          title: "Blockchain Transaction Fees (Gas Fees)",
          details:
            "Each transaction processed on the Songbird and Flare blockchains incurs a Gas Fee, which is paid to the network validators responsible for confirming and securing the transaction. These fees fluctuate based on network activity and are completely outside of The Catalyst’s control. Users are advised to review Gas Fee estimates provided by their digital wallet before confirming any transaction. The platform does not have the ability to modify, reimburse, or waive these fees under any circumstances.",
        },
        {
          title: "Fee Visibility and Acceptance",
          details:
            "Users acknowledge that all fees, commissions, and royalties are transparent and visible at the time of transaction. By proceeding with a transaction, users are deemed to have reviewed and accepted the applicable fees. Any disputes regarding fees must be addressed prior to confirming the transaction, as all fees are non-refundable once a transaction is processed.",
        },
        {
          title: "Smart Contract Fee Logic",
          details:
            "All Site fees and royalties are enforced by the platform’s smart contracts, which automatically calculate and distribute the relevant amounts at the point of sale. These smart contracts are programmed to apply the designated fee structures based on transaction type (e.g., primary or secondary sale) and asset status. Any updates to the fee structure will be communicated in advance to all users.",
        },
        {
          title: "Fee Adjustments",
          details:
            "The Catalyst reserves the right to make changes to the fee structure. Proposed changes may include adjustments to commission rates, the introduction of new fees, or alterations to the distribution of collected fees. Users will be notified of any changes to the fee structure before they take effect, allowing sufficient time to adapt to the new terms.",
        },
      ],
    },
    {
      id: "4.2",
      title: "Decentralized Trading Platform",
      description: [
        "The Catalyst operates as a decentralized Site where users can mint, list, buy, and transfer NFTs created by approved artists. The platform provides the infrastructure for these transactions but does not intervene in or control the individual agreements between buyers and sellers. All terms of sale, including the transfer of ownership and any additional benefits associated with an NFT, are the sole responsibility of the users involved in the transaction.",
      ],

      fees: [
        {
          title: "Direct Interaction with Smart Contracts",
          details:
            "Transactions on the Site are executed through smart contracts on the Songbird and Flare blockchains. Users initiate actions such as listing, purchasing, or transferring NFTs directly through their digital wallets. Once a transaction is confirmed on the blockchain, it cannot be reversed or modified. Users are responsible for ensuring they have sufficient funds and understanding the terms before initiating any transaction.",
        },
        {
          title: "Listing and Purchasing NFTs",
          details:
            "Users can list their NFTs for sale at a fixed price or through auctions. Each listing should accurately describe the NFT, including its metadata, ownership history, and any additional rights or benefits. All bids and offers are binding, and once accepted, the transaction is automatically processed through the blockchain.",
        },
        {
          title: "Secondary Market Sales",
          details:
            "The Site supports secondary market sales, allowing users to resell NFTs they have purchased. These sales are facilitated by smart contracts, ensuring the automatic deduction of creator royalties and platform fees. Sellers are responsible for providing accurate information about the NFT and any conditions of sale. Buyers assume the risks associated with secondary market transactions, including the potential for value fluctuation and the fulfillment of any additional promises made by the seller.",
        },
        {
          title: "Supplementary Agreements",
          details:
            "Creators or sellers may offer additional services, goods, or utilities associated with their NFTs. These agreements are independent of the NFT transaction itself and are not governed by The Catalyst. Users are responsible for negotiating and fulfilling any supplementary terms directly with the other party. The Catalyst does not endorse or enforce these agreements and assumes no liability for their fulfillment.",
        },
        {
          title: "User Responsibilities",
          details:
            "Sellers must ensure that all information provided in their listings is accurate and not misleading. Buyers should conduct their own research and verify the details of each listing before making a purchase. Both parties must comply with all applicable laws and regulations, including those related to intellectual property and consumer protection. The Catalyst reserves the right to remove listings or take action against users who violate these terms.",
        },
        {
          title: "Assumption of Risk",
          details:
            "All transactions on The Catalyst are conducted at the user’s own risk. The platform does not mediate disputes or provide recourse for failed transactions. Users acknowledge that they are participating in a speculative market and accept the risks associated with blockchain technology, including potential loss of funds or assets.",
        },
      ],
    },

    {
      id: "4.3",
      title: "Creator Royalties and Payments",
      description: [
        "The Catalyst implements a structured system for royalties and payments to ensure that creators are fairly compensated for their contributions to the platform. The following outlines how royalties and payments are managed within the Site:",
      ],
      fees: [
        {
          title: "Automatic Royalties on Secondary Sales",
          details:
            "Every time an NFT created on The Catalyst is sold on the secondary market, a royalty of 5% of the sale price is automatically paid to the original creator. This royalty is embedded in the smart contract associated with the NFT and is executed whenever a secondary sale occurs. The royalty system incentivizes creators to continue contributing high-quality content to the platform and ensures they benefit from the ongoing trading of their work.",
        },
        {
          title: "Distribution of Royalties",
          details:
            "The royalties are directly transferred to the creator’s designated digital wallet at the time of sale. The smart contract governing the NFT ensures that this payment is made automatically, without the need for intervention by either the buyer or seller. This system provides a transparent and reliable method of compensating creators, independent of the Site's control over the transaction.",
        },
        {
          title: "Off-Market Transactions and Royalty Exemptions",
          details:
            "The Catalyst's royalty system applies only to transactions conducted through the platform’s Site. Sales conducted outside of The Catalyst, such as through private agreements or other Sites, may not trigger the automatic royalty payment. Users engaging in off-market transactions are responsible for ensuring that any agreed-upon royalties are honored. The platform disclaims any responsibility for royalties not collected through its system.",
        },
        {
          title: "No Obligation for External Royalties",
          details:
            "While The Catalyst ensures royalty payments for secondary sales on its Site, it does not guarantee or enforce royalties on other platforms or private transactions. Creators and collectors must independently manage and negotiate any royalties due outside of The Catalyst ecosystem. Users are advised to be cautious when purchasing NFTs on external platforms, as the royalty configuration may not be compatible or recognized.",
        },
        {
          title: "Royalty Disputes",
          details:
            "Any disputes regarding royalty payments must be resolved directly between the involved parties. The Catalyst does not mediate disputes over royalties, nor does it have the authority to reverse or adjust royalty payments once they have been processed by the smart contract. Users are encouraged to carefully review the royalty configuration of an NFT before engaging in any transaction to avoid misunderstandings.",
        },
        {
          title: "Changes to Royalty Framework",
          details:
            "The Catalyst reserves the right to modify the royalty framework, including the maximum allowable royalty rate or the methods of distribution, to adapt to evolving market conditions and regulatory requirements. Any such changes will be communicated to users in advance and will only apply to NFTs minted after the effective date of the change. Existing NFTs will retain their original royalty configurations as specified at the time of minting.",
        },
      ],
    },

    {
      id: "4.5",
      title: "Off-Market Transactions and Compliance",
      description: [
        "Off-market transactions, which refer to any sale, transfer, or exchange of NFTs conducted outside the Site’s integrated platform and smart contracts, are not prohibited but come with certain conditions and risks. These transactions are not processed or recognized by The Catalyst’s smart contracts, meaning they do not trigger the automatic collection of platform fees or creator royalties embedded in the NFT’s smart contract. Users engaging in such activities are fully responsible for ensuring that any mutually agreed terms are honored, and The Catalyst disclaims all responsibility for losses or disputes arising from off-market transactions. It is crucial for users to conduct thorough due diligence and document all agreements in detail before proceeding with any off-market activity.",
        "Despite the flexibility offered by off-market transactions, users must not use these transactions to circumvent platform fees, creator royalties, or other contractual obligations associated with NFTs minted on The Catalyst. This includes conducting private sales or transfers specifically to avoid paying fees, delisting NFTs from The Catalyst to sell them privately, or manipulating smart contract terms in a way that undermines the enforcement of The Catalyst’s contractual conditions. Users found engaging in such activities may face account suspension, termination, or other actions deemed appropriate by The Catalyst. Furthermore, any NFTs involved in such activities may be restricted from future sales or transfers on the platform. The Catalyst does not provide support, mediation, or dispute resolution for issues related to off-market transactions. Users involved in these activities must resolve disputes independently and without recourse to the platform. The Catalyst reserves the right to take further legal action as necessary to protect the integrity of the platform and the rights of its creators. Users who become aware of any violations related to off-market transactions are encouraged to report such incidents to The Catalyst team, providing detailed information to facilitate a thorough investigation. ",
      ],
    },

    {
      id: "4.6",
      title: "Reporting Suspicious Activity",
      description: [
        "Users of the Site are encouraged to report any suspicious or potentially harmful activity they observe. This includes, but is not limited to, instances of market manipulation, fraud, intellectual property infringement, or violations of these Terms of Service. Prompt reporting of such activities helps maintain the integrity of the platform and ensures a fair trading environment for all participants. When submitting a report, users should provide as much detail as possible, including the nature of the suspicious activity, the parties involved, and any supporting evidence, such as transaction IDs or communication logs. All reports will be reviewed confidentially, and appropriate action will be taken based on the findings of the investigation. The Catalyst reserves the right to take measures such as suspending accounts, removing NFTs from the Site, or notifying legal authorities if necessary",
        "Reporting suspicious activity does not imply any liability or responsibility on the part of the reporting user. However, users should not abuse this process to make false or malicious claims against others. Misuse of the reporting system may result in penalties, including the suspension or termination of the user’s account. Users who report in good faith will be protected from any repercussions related to their involvement in the reported activities.        ",
      ],
    },

    {
      id: "4.7",
      title: "Compliance and Enforcement Actions",
      description: [
        "If a user is found to be in violation of these Terms, or if their activities pose a risk to the security or integrity of the Site, the Company reserves the right to take appropriate disciplinary actions. Such actions may include, but are not limited to, temporary or permanent suspension of the user’s account, removal of NFTs from the Site, restrictions on the user’s ability to buy, sell, or transfer NFTs, or the termination of access to certain features or services. In cases where violations are severe or repeated, the Company may pursue legal action to protect its interests and those of its users. The Company’s decisions regarding enforcement actions are final and are made at its sole discretion based on the circumstances of each case. ",
      ],
    },
    {
      id: "4.8",
      title: "Dispute Resolution and Legal Compliance",
      description: [
        "In the event of any disputes arising from the use of the Site, users agree to first attempt to resolve the issue informally by contacting us directly. The Catalyst is not responsible for resolving disputes between users regarding NFT transactions or any supplementary agreements made outside the platform. Users are encouraged to document all agreements in writing and communicate clearly to avoid misunderstandings. Users agree to waive their right to participate in any class or representative actions, ensuring that disputes are handled on an individual basis. Users must ensure that their activities on the Site comply with all applicable laws and regulations, including those related to anti-money laundering, consumer protection, and intellectual property rights, and are prohibited from using the Site for any illegal or unauthorized purposes. The Company reserves the right to cooperate with law enforcement and regulatory authorities in the investigation of any suspected illegal activities, including providing information related to user accounts, transactions, and digital assets. Non-compliance with these legal obligations may result in severe penalties, including account suspension, termination, and the forfeiture of digital assets associated with the user’s account.",
      ],
    },
    {
      id: "4.9",
      title: "Termination and Suspension of Services",
      description: [
        "The Catalyst reserves the right to terminate or suspend a user’s access to the Site at any time, with or without notice, for violations of these Terms, suspected fraudulent activity, or any other reason deemed necessary to protect the integrity of the platform and its community. Users whose accounts have been suspended or terminated are prohibited from creating new accounts or accessing the Site through any other means. The Company may also restrict access to specific features or services, such as the ability to buy, sell, or transfer NFTs, in response to any violations or risks identified during routine monitoring or as a result of user reports.",
        "Upon termination or suspension, users will no longer have access to their account, associated NFTs, or any digital assets stored within their account. The Company is not responsible for any losses or damages incurred as a result of termination or suspension actions. Users are encouraged to regularly back up any important information and to remain compliant with these Terms to avoid interruptions to their access and use of the Site",
        "If a user believes their account has been wrongfully suspended or terminated, they may contact the Company to request a review of the decision. The Company will review all such requests and make a final determination based on the evidence provided. Users are reminded that the Company’s decisions regarding account suspensions, terminations, or restrictions are final and are made in the best interest of maintaining a safe and secure platform for all participants.",
      ],
    },
  ];
  const creator = [
    {
      id: "5.1",
      title: "Ownership and Rights of Creator NFTs",
      description: [
        "Creator NFTs are unique digital assets minted by artists who have been whitelisted and approved to participate on The Catalyst. These NFTs, adhering to the ERC-721 standard, are cryptographically authenticated and represent a single, exclusive piece of digital artwork. Each Creator NFT is a one-of-a-kind edition. The Catalyst may showcase and promote these NFTs through the Site and reserves the right to index and make them accessible to users. Although the value of any Creator NFT is inherently subjective and depends on market sentiment, they are primarily intended for the personal enjoyment and appreciation of their owners. Ownership of a Creator NFT is defined by the records on the Songbird and Flare blockchains, indicating that your digital wallet possesses the NFT. This ownership confers control over the NFT token itself but does not grant rights to the underlying digital artwork, including intellectual property rights such as copyrights or trademarks. The creator retains all such rights, and ownership of the NFT is limited to the possession of the token, akin to owning a physical piece of art without owning the rights to reproduce or modify it. This means that as an owner, you have the right to display the digital artwork for personal, non-commercial use, but you may not reproduce, distribute, or use it commercially unless you have obtained explicit permission from the creator. It is important to note that the rights associated with the NFT do not include any form of intellectual property ownership over the digital artwork it represents.",
      ],
    },
    {
      id: "5.2",
      title: "Exclusivity of Single-Edition NFTs",
      description: [
        "The Catalyst exclusively supports single-edition, 1-of-1 NFTs, which means that each NFT represents a unique digital artwork and no duplicates are allowed. Any attempt to mint, distribute, or display duplicate versions of a Creator NFT, either on The Catalyst or elsewhere, is a violation of these Terms. The uniqueness of each NFT is ensured by its token ID and metadata, which are embedded in the blockchain at the time of minting. If you become aware of any duplicate NFTs that reference the same artwork, it is your responsibility to report this to The Catalyst team for immediate investigation and resolution. Such duplicates undermine the value and authenticity of the original NFT, and the platform is committed to taking necessary action against any such infringement.",
      ],
    },
    {
      id: "5.3",
      title: "Limited License for NFT Owners",
      description: [
        "As the owner of a Creator NFT, you are granted a limited, non-commercial license to use the associated digital artwork for specific purposes. This includes displaying the artwork in your personal collection, on social media platforms, or within virtual galleries. You may also use the artwork in connection with the sale, transfer, or trading of the NFT on third-party platforms, provided that these platforms authenticate your ownership. This license does not permit you to modify the artwork, create derivative works, or use it for commercial purposes without the explicit consent of the creator. The enjoyment of this license is linked directly to your ownership of the NFT, and any resale royalties paid to the creator upon the transfer of the NFT serve as consideration for the limited rights you enjoy while owning the NFT. If you wish to use the digital artwork beyond the scope of this license, such as for commercial exploitation, you must negotiate a separate agreement with the creator. The creator is under no obligation to grant such permissions, and any commercial use without explicit authorization is strictly prohibited.",
      ],
    },
    {
      id: "5.4",
      title: "Restrictions on Use and Modification",
      description: [
        "All rights to the digital artwork associated with the NFT are reserved by the creator. This means that as an NFT owner, you are prohibited from modifying, reproducing, or using the artwork in any way that could harm the creator's reputation or violate their rights. This includes creating derivative works, using the artwork in association with illegal or unethical content, or attempting to claim intellectual property rights over the artwork. Additionally, you may not use the artwork for any commercial purposes, such as producing merchandise or advertising, without the creator's express permission. Any misuse or unauthorized exploitation of the artwork will be considered a violation of these Terms.",
      ],
    },
    {
      id: "5.5",
      title: "Termination of License Upon Transfer",
      description: [
        "The license granted to you as the owner of a Creator NFT is inherently tied to your ownership of the NFT. Upon the sale, transfer, or any other form of disposal of the  transfer of the NFT, as recorded on the blockchain. This license is non-transferable, non-assignable, and non-sublicensable beyond the ownership of the NFT itself. Any attempt to transfer or sublicense the rights associated with the NFT outside of an actual transfer of the NFT token is void and unenforceable. This ensures that the integrity of the license remains intact and that each owner is bound by the same terms.",
      ],
    },
    {
      id: "5.6",
      title: "Compliance with Investigations",
      description: [
        "If an NFT becomes the subject of a dispute or investigation, the owner is required to fully comply with any requests from The Catalyst. This may include providing information related to the acquisition and use of the NFT, as well as refraining from any further transactions involving the disputed NFT until the issue is resolved. Failure to comply with such requests may result in restrictions on your account, including the temporary suspension of your ability to transfer or sell NFTs. The Catalyst is committed to maintaining a fair and transparent platform, and all users are expected to act in good faith in the event of any disputes or investigations.",
      ],
    },
  ];

  const creators = [
    {
      title: "6.1 Creators",
      description: [
        "Creators on The Catalyst are artists who have been selected through a whitelisting process to mint exclusive, 1-of-1 NFTs on the platform. This process is designed to ensure that only artists with unique and original digital artworks are able to participate, thereby maintaining the platform’s standards for quality and authenticity. Creators can apply for whitelisting by submitting their portfolios and relevant information through the platform’s application process. An admin then reviews these applications and selects those who meet the criteria for approval. This process allows for a diverse range of artists to join while preserving the integrity of the platform. Once approved, creators can utilize The Catalyst’s smart contracts and infrastructure to mint NFTs, adhering to the ERC-721 standard. This exclusivity ensures that each Creator NFT represents a singular, unique piece of digital art, enhancing its value and appeal within the marketplace. Approved creators have the ability to mint NFTs directly on The Catalyst by uploading their original digital artworks. This process requires the creator to provide detailed metadata, including the title, description, and other attributes that accurately represent the artwork. By proceeding with the minting process, creators confirm that the uploaded content is their original work and that they have the legal rights to mint and sell it as an NFT. The minting process is designed to be user-friendly, enabling artists to easily navigate through the steps required to tokenize their work.",
      ],
    },

    {
      title: "6.2 NFT Content",
      description: [
        "Creators on The Catalyst must ensure that all content they mint is original and free from any third-party claims. This means that the digital artwork and any associated elements, such as music or branding, must either be created entirely by the artist or used with the appropriate permissions. Creators are expressly prohibited from minting NFTs that incorporate content for which they do not hold the necessary rights or licenses. This includes artwork created under work-for-hire agreements, collaborative works where copyright ownership is shared or unclear, and any content that is subject to a legal dispute or claim. In cases where a Creator NFT includes third-party content, such as licensed music or images, the creator must be able to demonstrate that they have the legal right to use and mint this content. This may require presenting licenses, agreements, or other documentation that confirms their authority to use the material in the NFT. The Catalyst reserves the right to request such documentation at any time and may suspend or remove NFTs that are found to violate these requirements. Creators are also responsible for ensuring that their use of third-party content falls within the bounds of fair use or other applicable legal doctrines, and they should seek legal advice if they are uncertain about the legality of their content. Minting unauthorized or infringing content can lead to severe consequences, including the suspension of the creator’s account and the removal of all associated NFTs from the platform. Additionally, creators may be held liable for any damages or legal costs incurred by The Catalyst or affected third parties as a result of their actions.",
      ],
    },

    {
      title: "6.3 Authenticity",
      description: [
        "The Catalyst is committed to maintaining the exclusivity and authenticity of each Creator NFT. To this end, creators are strictly prohibited from minting multiple NFTs that reference the same digital artwork. This rule applies not only to The Catalyst but also to other platforms and marketplaces. Once an NFT is minted on The Catalyst, the creator may not mint another NFT or digital collectible that references the same artwork, regardless of the platform or context. If a creator is found to be in violation of this no double minting policy, The Catalyst reserves the right to take corrective actions, including but not limited to the removal of the duplicate NFT, suspension of the creator’s account, and legal action if necessary. Creators must inform The Catalyst immediately if they become aware of any duplicate NFTs or unauthorized use of their artwork. In certain cases, such as accidental minting errors or compromised accounts, The Catalyst may work with the creator to resolve the issue in a fair and transparent manner. To further protect the uniqueness of Creator NFTs, The Catalyst encourages creators to maintain clear records of their minting activities and to communicate openly with the platform regarding any potential issues. This proactive approach helps prevent misunderstandings and ensures that all parties are aligned in their commitment to preserving the value and integrity of each NFT. Creators who intentionally or repeatedly violate this policy may be permanently banned from the platform.",
      ],
    },
    {
      title: "6.4 Limited License for NFT Owners",
      description: [
        "Owners of Creator NFTs are granted a limited, non-commercial license to use the associated digital artwork for personal purposes only. This license allows owners to display the artwork in their personal collections, share it on social media, or use it as a profile picture. The license also permits the use of the artwork in virtual environments, such as online galleries or digital displays, as long as the usage remains non-commercial and respects the rights of the creator. This license does not grant the owner any rights to modify, reproduce, or commercially exploit the digital artwork in any way. Any use of the artwork that falls outside the scope of this license, such as creating merchandise or using the artwork for promotional purposes, requires the explicit permission of the creator. Owners are also prohibited from using the artwork in any context that could harm the creator’s reputation or infringe upon their rights, such as associating the artwork with hate speech, violence, or illegal activities. The limited license is automatically terminated if the owner sells or transfers the NFT.  The new owner of the NFT will receive the same license upon the successful transfer of the NFT as recorded on the blockchain. This ensures that the rights associated with the NFT remain consistent and that each new owner is subject to the same terms and conditions. Any attempt to transfer or sublicense the rights associated with the NFT outside of an actual transfer of the NFT token is void and unenforceable. ",
      ],
    },
    {
      title: "6.5 Prohibited Content and Activities",
      description: [
        "Creators on The Catalyst must adhere to strict guidelines regarding the content they mint and promote on the platform. This includes a prohibition on any content that is illegal, defamatory, obscene, or otherwise inappropriate. Creators are also prohibited from minting content that promotes hate speech, violence, discrimination, or any other harmful or offensive material. The Catalyst reserves the right to remove any content that violates these standards and to suspend or terminate the accounts of creators who engage in such activities. To help maintain a safe and respectful community, The Catalyst encourages creators to accurately tag any content that may be considered Not Safe For Work (NSFW) or otherwise sensitive. This helps ensure that users are aware of the nature of the content and can make informed decisions about their interactions with it. Creators who fail to properly tag their content may have their NFTs removed from the platform and their accounts suspended or terminated.",
      ],
    },
    {
      title: "6.6 Termination of License Upon Transfer",
      description: [
        "The limited license granted to the owner of a Creator NFT is directly linked to the ownership of the NFT itself. Upon the sale or transfer of the NFT, all rights associated with this license immediately terminate, and the new owner receives the same limited license once the transfer is confirmed on the blockchain. This ensures that the rights associated with the NFT remain consistent and that each new owner is subject to the same terms and conditions. The termination of the license upon transfer is automatic and does not require any additional action by the former owner. However, former owners are prohibited from continuing to use the digital artwork in any way that would violate the terms of the terminated license. This includes displaying the artwork, sharing it on social media, or using it in virtual environments. Creators are expected to cooperate fully with any inquiries related to their activities on The Catalyst. This includes providing information about their NFTs, minting activities, and any third-party content included in their works. If a Creator NFT becomes the subject of a legal dispute or investigation, the creator must refrain from selling, transferring, or otherwise engaging in transactions involving the disputed NFT until the issue is resolved. Failure to comply with these requirements may result in restrictions on the creator’s account, including the suspension of their ability to mint or sell NFTs. In serious cases, non-compliance could lead to permanent account termination. The Catalyst reserves the right to take any measures necessary to protect the platform's integrity and uphold the rights of its community members. This may include temporarily freezing the NFT in question, preventing its transfer or sale until the investigation is complete. Creators are encouraged to respond promptly to any inquiries and to provide accurate and comprehensive information to facilitate a swift and fair resolution of any disputes. If a creator is found to have engaged in activities that violate the platform's policies, The Catalyst may impose additional penalties, including the removal of all their minted NFTs from the platform and banning them from future participation. Such actions are taken to maintain a safe and compliant environment for all users and to protect the intellectual property and other rights of the community. Creators who are unsure about their obligations or the legality of their content should seek legal advice to avoid potential issues.",
      ],
    },
    {
      title: "6.7 Indemnification and Liability",
      description: [
        "By participating on The Catalyst, creators agree to indemnify, defend, and hold harmless The Catalyst and its affiliates, employees, and representatives from any claims, damages, or expenses arising out of their activities on the platform. This includes, but is not limited to, any claims of intellectual property infringement, breach of contract, or violation of applicable laws or regulations related to the content they mint and promote. Creators are responsible for ensuring that their NFTs do not infringe on the rights of any third parties and that they have obtained all necessary permissions and licenses for any content used in their works. If a third party brings a claim against The Catalyst related to a creator's NFT, the creator agrees to fully cooperate with The Catalyst in defending against the claim and to cover any costs, including legal fees, associated with the defense. In addition to indemnification, creators acknowledge that The Catalyst is not liable for any loss, damage, or injury resulting from their use of the platform. This includes, but is not limited to, losses related to the value or marketability of NFTs, technical issues, or disputes with other users. Creators use the platform at their own risk and are solely responsible for their actions and the content they choose to mint and sell. The Catalyst makes no representations or warranties about the suitability, reliability, or availability of its services for any particular purpose and disclaims all liability to the fullest extent permitted by law. By agreeing to these terms, creators accept full responsibility for their activities on The Catalyst and understand that they may be held liable for any violations of these terms. Creators are encouraged to familiarize themselves with the platform's policies and to seek legal advice if they have any questions or concerns about their rights and obligations. This proactive approach helps ensure compliance and protects both the creators and the platform from potential legal issues.",
      ],
    },
  ];

  const disputes = [
    {
      title: "7.1 Reporting Intellectual Property Infringement",
      description: [
        "If you believe that any content on The Catalyst infringes your intellectual property rights, you are encouraged to contact our team directly to report the issue. This can include claims related to copyright, trademarks, rights of publicity, or other intellectual property concerns. When reporting an issue, you should provide as much detailed information as possible, including:",
      ],
      conclusion: [
        "Our team will review your complaint and take appropriate action, which may include temporarily removing or restricting access to the content in question while the matter is investigated. Please note that submitting a false or misleading report of infringement may result in penalties, including the suspension or termination of your account.",
      ],
      fees: [
        {
          title: "",
          details:
            "A description of the content you believe to be infringing, including any relevant URLs or specific identifiers",
        },
        {
          title: "",
          details:
            "Proof of your ownership or authorization to act on behalf of the rights holder",
        },
        {
          title: "",
          details:
            "A statement explaining why you believe the content infringes your rights.",
        },
        {
          title: "",
          details:
            "Your contact information, including an email address, to facilitate communication.",
        },
      ],
    },

    {
      title: "7.2 Mediation and Resolution Process",
      description: [
        "The Catalyst aims to mediate disputes between the rights holder and the alleged infringer to reach a fair and amicable resolution. Once a complaint is received, we will notify the creator of the disputed content and provide them with an opportunity to respond. This initial step is crucial in ensuring that both parties have a chance to present their perspectives before any further action is taken.",
        "During this process, the following steps will be taken:",
      ],
      conclusion: [
        "If the parties cannot reach a resolution through mediation, The Catalyst reserves the right to make a final determination based on the information available. Our decision may include account suspension or termination for the creator if the content is found to be infringing. ",
      ],
      fees: [
        {
          title: "Notification to the Creator",
          details:
            " The creator of the disputed content will be informed of the complaint and given a chance to provide a counter-statement or evidence supporting their right to use the content.",
        },
        {
          title: "Review and Mediation",
          details:
            " Our team will review the information provided by both parties and may request additional details if needed. We will make reasonable efforts to mediate between the parties to facilitate a settlement.",
        },
        {
          title: "Resolution",
          details:
            "Depending on the outcome of the mediation, several actions may be taken, including restoring the content, modifying it to remove the infringing elements, or permanently removing it from the platform. If a settlement is reached between the parties, we will assist in implementing the agreed-upon solution.",
        },
      ],
    },

    {
      title: "7.3 Account Suspension and Termination for Infringement",
      description: [
        "The Catalyst has a zero-tolerance policy for intellectual property infringement. If a creator is found to have repeatedly or egregiously infringed upon the rights of others, their account may be permanently banned from the platform. This policy applies to any form of infringement, whether it involves copyright, trademarks, or other intellectual property rights.",
        "Factors that may result in an immediate account suspension or termination include:",
      ],
      conclusion: [
        "Account termination is a serious action and will be considered only when there is clear evidence of infringement or when a user has demonstrated a pattern of behavior that violates these terms. Users who are banned for infringement will lose access to their accounts and any associated content. They will also be prohibited from re-registering on the platform.",
      ],
      fees: [
        {
          title: "",
          details: "Repeated infringement complaints against the same user",
        },
        {
          title: "",
          details:
            "Evidence of intentional or malicious infringement, such as minting stolen artworks or using copyrighted content without permission.",
        },
        {
          title: "",
          details:
            " Failure to comply with our mediation process or refusal to cooperate in resolving disputes.",
        },
      ],
    },

    {
      title: "7.4 Content Removal and Restoration",
      description: [
        "When content is removed from The Catalyst due to an intellectual property dispute, the creator will be notified and given an opportunity to respond. If the creator provides sufficient evidence that the content does not infringe on any rights, it may be restored to the platform. However, this decision is at the sole discretion of The Catalyst and will be made based on the merits of each case. If the content is permanently removed, the creator may also be required to take further actions, such as transferring ownership of the disputed NFTs or compensating affected parties, depending on the nature of the dispute and the resolution agreed upon by the parties involved. The Catalyst will not be liable for any loss of value or disruption caused by the removal of content. Creators and collectors should be aware of the risks associated with engaging in NFT transactions and are encouraged to conduct due diligence before purchasing or minting any digital assets. All users of The Catalyst, including creators and collectors, are expected to cooperate fully with the platform’s procedures for handling intellectual property disputes. This includes responding promptly to any inquiries, providing accurate information, and participating in mediation efforts when requested. Failure to comply with these requirements may result in account suspension or other penalties. Users are also encouraged to seek legal advice if they are unsure about their rights or obligations under these terms. The Catalyst is not responsible for providing legal guidance and will not offer interpretations of intellectual property law beyond what is stated in these terms. The Catalyst’s platform operates using smart contracts that facilitate the minting, buying, and selling of NFTs. These smart contracts are automated and do not have the ability to discern whether the content they are processing infringes on intellectual property rights. As such, it is the responsibility of the creator to ensure that any content they mint is compliant with these terms and does not infringe on the rights of others. If a dispute arises regarding content that has been minted, transferred, or sold through a smart contract, The Catalyst will make every effort to address the issue in accordance with these terms. However, the immutable nature of blockchain transactions means that certain actions, such as reversing a sale or transferring ownership of an NFT, may not be possible. Users should be aware of these limitations when engaging with the platform and understand that The Catalyst’s ability to intervene in disputes is subject to the technical constraints of the underlying blockchain technology   ",
      ],
    },

    {
      title: "7.5 Prohibited Activities Related to Intellectual Property",
      description: [
        "To protect the integrity of the platform and the rights of all users, The Catalyst prohibits the following activities related to intellectual property:",
      ],
      conclusion: [
        "Users who engage in any of these activities may face penalties, including the suspension or termination of their accounts and the removal of any infringing content from the platform. The Catalyst reserves the right to take any action deemed necessary to enforce these policies and protect the rights of its community members.",
      ],
      fees: [
        {
          title: "Minting Unauthorized Content",
          details:
            "Minting NFTs that include content for which the creator does not have the necessary rights, licenses, or permissions is strictly prohibited.",
        },
        {
          title: "Circumventing Platform Policies",
          details:
            "Attempting to bypass The Catalyst’s policies or restrictions regarding content removal, account suspension, or other enforcement actions related to intellectual property disputes.",
        },
        {
          title: "Misrepresentation of Rights",
          details:
            "Falsely claiming ownership or rights to content, or misrepresenting the scope of permissions granted by third parties, is prohibited and may result in immediate account termination.",
        },
        {
          title: " Interfering with Dispute Resolution",
          details:
            "Obstructing or interfering with the platform’s procedures for handling intellectual property disputes, including failing to comply with mediation efforts or providing false information, is strictly prohibited.",
        },
      ],
    },

    {
      title: "7.6 User Indemnification for Intellectual Property Infringement",
      description: [
        "By using The Catalyst, creators and other users agree to indemnify and hold harmless The Catalyst and its affiliates from any claims, damages, or expenses arising from their activities on the platform, including but not limited to intellectual property disputes. This includes covering any legal costs incurred by The Catalyst in responding to claims or disputes related to user-uploaded content. Users are solely responsible for ensuring that their activities on the platform comply with these terms and do not infringe on the rights of others. In the event of a dispute, users agree to cooperate fully with The Catalyst and to provide any information or assistance needed to resolve the issue. Failure to do so may result in penalties, including account suspension or termination.",
      ],
    },
    {
      title: "7.8 Limitation of Liability",
      description: [
        "The Catalyst is not liable for any loss, damage, or injury resulting from disputes over intellectual property rights. This includes, but is not limited to, losses related to the removal of content, account suspensions, or any disruptions to the platform’s services. Users engage with the platform at their own risk and are responsible for their actions and the content they choose to mint, buy, or sell. The Catalyst makes no representations or warranties about the legality, validity, or quality of any content on the platform and disclaims all liability to the fullest extent permitted by law. Users are encouraged to conduct their own due diligence before engaging in any transactions and to seek legal advice if they have concerns about their rights or obligations.",
      ],
    },
  ];

  const limitation = [
    {
      title: "8.1 Limitations on Liability      ",
      description: [
        "The Catalyst, its affiliates, officers, directors, employees, agents, licensors, and any   associated entities (collectively, “The Catalyst Parties”) will not be liable for any indirect,   incidental, special, consequential, or punitive damages, including, but not limited to, loss of   profits, data, goodwill, or other intangible losses, resulting from:",
      ],

      fees: [
        {
          title: "Use of the Platform:",
          details:
            "Your use of, or inability to use, The Catalyst platform, including any associated content, NFTs, or other digital assets.",
        },
        {
          title: "Third-Party Interactions:",
          details:
            "Any conduct, content, goods, services, or transactions of third parties accessed or interacted with through the platform. This includes any disputes between users or between users and third-party service providers.",
        },
        {
          title: "Blockchain Technology:",
          details:
            "Errors, malfunctions, or other issues arising from the Songbird and Flare blockchains, including delayed, lost, or reversed transactions, smart contract failures, or vulnerabilities in the blockchain infrastructure.",
        },
        {
          title: "Security Breaches:",
          details:
            "Unauthorized access to or alteration of your account, digital wallet, or content due to hacking, phishing, or other unauthorized activities by third parties.",
        },
        {
          title: "Operational Interruptions:",
          details:
            "Service outages, delays, or interruptions caused by system maintenance, technical failures, or other unforeseen circumstances that may prevent access to the platform or affect its functionality.",
        },
      ],
    },

    {
      title: "8.2 Limitation on Monetary Damages",
      description: [
        "In no event will The Catalyst Parties' total liability to you for all claims arising out of or related  to these Terms, the use or inability to use the platform, or any NFTs or digital assets on the  platform exceed the greater of:",
      ],
      conclusion: [
        "This limitation on liability applies to all types of claims, including those based on contract, tort    (including negligence), strict liability, or any other legal theory, even if The Catalyst Parties    have been advised of the possibility of such damages.",
      ],
      fees: [
        {
          title: "",
          details:
            "The total amount of fees you have paid to The Catalyst in the twelve months preceding the date of the claim, or",
        },
        {
          title: "",
          details: "One hundred Great British Pounds (£100)..",
        },
      ],
    },

    {
      title: "8.3 Exclusions and Exceptions",
      description: [
        "Certain jurisdictions do not allow the exclusion or limitation of certain types of damages,         such as incidental or consequential damages. As such, the limitations and exclusions set         forth in these Terms may not apply to you. If any part of this limitation of liability is found to         be unenforceable in a particular jurisdiction, the remaining parts will still apply to the fullest         extent permitted by law.",
      ],
    },

    {
      title: "8.4 User Responsibilities",
      description: [
        "Users are responsible for conducting their own research and due diligence before engaging in any transactions on the platform. This includes evaluating the risks associated with blockchain technology, NFTs, and digital assets. The Catalyst does not provide financial, legal, or investment advice, and users are solely responsible for their actions on the platform.",
      ],
    },

    {
      title: "8.5 Acknowledgment of Risks",
      description: [
        "By using the platform, you acknowledge and accept the inherent risks associated with    blockchain technology and NFTs. These risks include, but are not limited to, the potential for    loss of digital assets, technical vulnerabilities in smart contracts, fluctuations in the value of    cryptocurrencies, and the possibility of legal and regulatory changes that could impact the    platform and its users.",
      ],
    },
  ];

  const dispute = [
    {
      title: "9.1 Agreement to Arbitrate",
      description: [
        "By accessing or using The Catalyst platform, you agree that any disputes, claims, or  controversies arising out of or relating to these Terms, the platform, or your use of the  platform will be resolved through binding arbitration. This means that you waive your right to  a court trial or to participate in any form of class action lawsuit. Arbitration is a less formal  process than court proceedings and typically involves a neutral arbitrator instead of a judge  or jury.",
      ],
    },

    {
      title: "9.2 Class Action Waiver",
      description: [
        "You agree to resolve any disputes with The Catalyst on an individual basis and waive your      right to participate in a class action or class-wide arbitration. This means that you cannot      bring a claim as a plaintiff or class member in any purported class action, collective, or      representative proceeding.",
      ],
    },
  ];

  const survival = [
    {
      title: "10.1 Continuing Obligations      ",
      description: [
        "The provisions of these Terms that, by their nature, should survive termination of your relationship with The Catalyst will continue to apply. This includes, but is not limited to:",
      ],

      fees: [
        {
          title: "Ownership Rights:",
          details:
            "Any rights related to the ownership and intellectual property of content created, uploaded, or interacted with on the platform.",
        },
        {
          title: "Disclaimers & Limitation of Liability:",
          details:
            "All disclaimers of warranties and limitations of liability outlined in these Terms.",
        },
        {
          title: "Indemnification:",
          details:
            "Your obligation to indemnify The Catalyst for any claims related to your use of the platform.",
        },
      ],
    },

    {
      title: "10.2 License Rights      ",
      description: [
        "The licenses granted to The Catalyst for the use of content you have uploaded or created on the platform will continue to apply unless otherwise stated. This includes licenses granted for promotional use, development, or other purposes specified in these Terms.",
      ],
    },
    {
      title: "10.3 Termination of Access      ",
      description: [
        "Even if your access to the platform is terminated, The Catalyst reserves the right to use any  content or data you have contributed in accordance with the licenses you granted during  your use of the platform",
      ],
    },
    {
      title: "10.4 Dispute Resolution  ",
      description: [
        "The agreement to resolve disputes through arbitration will survive the termination of your use   of the platform. This means that any disputes arising after your use of the platform has   ended will still be subject to arbitration as outlined in these Terms.",
      ],
    },
    {
      title: "10.5 General Provisions      ",
      description: [
        "The general provisions of these Terms, including severability, waiver, and entire agreement    clauses, will continue to apply after your use of the platform has ended. These provisions    ensure that the remainder of the agreement remains in effect even if one part is found to be    invalid or unenforceable.",
      ],
    },
  ];

  const termination = [
    {
      title: "11.1 Termination for Breach",
      description: [
        "The Catalyst reserves the right to terminate or suspend your access to the platform at any time, with or without notice, for any violation of these Terms. This includes, but is not limited to, engaging in fraudulent activities, violating intellectual property rights, attempting to manipulate or exploit the platform, or any other conduct deemed harmful to The Catalyst.",
        "Once your access is terminated, you may lose access to your account and any associated digital assets or NFTs. The Catalyst is not obligated to compensate you for any losses resulting from such termination.",
      ],
    },
    {
      title: "11.2 User Responsibilities Upon Termination",
      description: [
        "If your account is terminated or suspended, you must immediately cease all use of the platform. You are prohibited from creating a new account or attempting to access the platform through other means. Any remaining obligations under these Terms, including payment of fees or compliance with intellectual property rights, will survive termination.",
      ],
    },
    {
      title: "11.3 Termination of NFT Listings",
      description: [
        "Upon termination of your access, The Catalyst reserves the right to remove any NFT listings, auctions, or other content associated with your account. This action may include delisting your NFTs from the marketplace, canceling any ongoing transactions, and restricting your ability to transfer NFTs using The Catalyst’s smart contracts.",
      ],
    },
    {
      title: "11.4 Termination by User",
      description: [
        "You may terminate your use of The Catalyst platform at any time by contacting us. Upon termination, you will no longer have access to your account, and any digital assets or NFTs linked to your account may become inaccessible through the platform.",
      ],
    },
    {
      title: "11.5 No Refunds or Compensation",
      description: [
        "The Catalyst is not liable for any compensation, reimbursement, or damages arising from the loss of access to your account, the termination of your account, or the removal of any content associated with your account. This includes, but is not limited to, loss of profits, revenues, data, or opportunities.",
      ],
    },
    {
      title: "11.6 Reinstatement of Access",
      description: [
        "The Catalyst may, at its sole discretion, reinstate access to terminated accounts upon resolution of the issue that led to termination. However, The Catalyst is under no obligation to do so, and any decision to reinstate access is final and not subject to further negotiation or appeal.",
      ],
    },
    {
      title: "11.7 Right to Refuse Service",
      description: [
        "The Catalyst reserves the right to refuse service to anyone at any time, for any reason. This includes refusing to grant access to the platform, deny the ability to mint or trade NFTs, or restricting participation in any platform activities.  This right is exercised solely at The Catalyst’s discretion and is not subject to negotiation.",
      ],
    },
  ];

  const miscellaneous = [
    {
      title: "12.1 Entire Agreement",
      description: [
        "These Terms, along with any policies or guidelines incorporated by reference, constitute the entire agreement between you and The Catalyst concerning your use of the platform. This agreement supersedes all prior and contemporaneous understandings, agreements, representations, and warranties, both written and oral, regarding the platform.",
      ],
    },
    {
      title: "12.2 Severability",
      description: [
        "If any provision of these Terms is found to be invalid or unenforceable by a court of competent jurisdiction, the invalidity or unenforceability of such provision will not affect the validity or enforceability of the remaining provisions, which will remain in full force and effect. Each provision of these Terms shall be considered severable and independent from the others.",
      ],
    },
    {
      title: "12.3 Waiver",
      description: [
        "The failure of The Catalyst to enforce any right or provision in these Terms will not constitute a waiver of such right or provision unless acknowledged and agreed to by The Catalyst in writing. Any waiver of a breach or default under these Terms does not constitute a waiver of any subsequent breach or default.",
      ],
    },
    {
      title: "12.4 Assignment",
      description: [
        "You may not assign or transfer any rights or obligations under these Terms without The Catalyst’s prior written consent. Any attempted assignment or transfer in violation of this provision will be null and void. The Catalyst may freely assign or transfer its rights and obligations under these Terms without restriction, including to any successor in interest, affiliate, or third party in connection with a merger, acquisition, or sale of assets.",
      ],
    },
    {
      title: "12.5 Force Majeure",
      description: [
        "The Catalyst will not be liable for any delay or failure to perform its obligations under these Terms due to events beyond its reasonable control, including but not limited to natural disasters, acts of God, war, terrorism, riots, labor disputes, pandemics, governmental actions, or disruptions in telecommunications, power, or the internet. In such cases, The Catalyst’s obligations under these Terms will be suspended for the duration of the event.",
      ],
    },
    {
      title: "12.6 Governing Law and Jurisdiction",
      description: [
        "These Terms will be governed by and construed in accordance with the laws applicable in the jurisdiction in which The Catalyst operates, without regard to its conflict of law principles. Any disputes arising out of or relating to these Terms or the platform will be resolved in the courts of the jurisdiction where The Catalyst operates, subject to any arbitration requirements outlined in these Terms.",
      ],
    },
    {
      title: "12.7 No Third-Party Beneficiaries",
      description: [
        "These Terms are intended solely for the benefit of the parties and do not confer any rights or benefits on any third party. No other person or entity will have any rights to enforce any terms or conditions contained in these Terms.",
      ],
    },
    {
      title: "12.8 Survival of Terms",
      description: [
        "The provisions of these Terms that by their nature should survive the termination of your use of the platform will continue to apply. This includes, but is not limited to, provisions regarding intellectual property rights, limitation of liability, dispute resolution, and indemnification.",
      ],
    },
    {
      title: "12.9 Changes to the Terms",
      description: [
        "The Catalyst reserves the right to modify, update, or revise these Terms at any time, in its sole discretion. Any changes to these Terms will be effective immediately upon posting to the platform. It is your responsibility to review these Terms periodically for any changes. Continued use of the platform after changes have been made constitutes your acceptance of the revised Terms.",
      ],
    },
  ];

  return (
    <>
      <div className="catalyst-content privacy-page">
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          {/* <label className="medium">Help Center</label> */}
          <h4 className="medium-head">1. Introduction</h4>
          <p className="body-large mt-36 pb-5  ">
            Welcome to The Catalyst, owned and operated by Fat Cats Club Ltd.
            (“the Company”, “we,” “us,” or “our”). [www.the-catalyst.xyz] (the
            “Site”) is a platform designed for the creation, sale, purchase, and
            exchange of digital art as non-fungible tokens (NFTs). The Catalyst
            serves as a web-based interface that facilitates peer-to-peer
            interactions among users within this digital art space, operating on
            the Songbird network and the Flare network. The platform enables
            users to mint, sell, buy, curate, display, auction, and engage with
            digital art.
            <br />
            <br />
            <b>
              Please review these Terms of Service carefully. They include
              important legal stipulations that limit your rights, such as
              restrictions on your ability to bring court actions, claim jury
              trials, participate in any class or representative actions, engage
              in discovery except as permitted under applicable arbitration
              rules, and access certain remedies and forms of relief.
            </b>
            <br />
            <br />
            These Terms of Service (“Terms” or “Agreement”) are entered into
            between You (the "Artist" or "Owner", together with others using the
            Site - collectively referred to as "Users"), and the Company. These
            Terms govern your access to and use of the Site, a web-based
            interface that facilitates peer-to-peer interactions among Users for
            the creation, sale, purchase, and exchange of digital art as
            non-fungible tokens (NFTs) on the Songbird network and the Flare
            network. By engaging with the Site, you accept these Terms in full.
            If you disagree with any part of the Terms, you must cease using the
            Site immediately.
          </p>

          <div>
            {terms.map((item, index) => {
              return (
                <div className="d-flex flex-column   pb-3">
                  <p className="body-large mb-2">
                    <b>
                      {item?.id} {item?.title}
                    </b>
                  </p>

                  <>
                    {item?.description?.map((desc, index) => (
                      <>
                        <p key={index} className="body-large">
                          {desc} {item?.privacyPolicyLink}
                        </p>
                        <br />
                      </>
                    ))}
                  </>
                </div>
              );
            })}
          </div>
        </div>
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          {/* <label className="medium">Help Center</label> */}
          <h4 className="medium-head mb-3">2. Using The Service</h4>

          <div>
            {services.map((item, index) => {
              return (
                <div className="d-flex flex-column   pb-3">
                  <p className="body-large mb-2">
                    <b>
                      {item?.id} {item?.title}
                    </b>
                  </p>

                  <>
                    {item?.description?.map((desc, index) => (
                      <>
                        <p key={index} className="body-large">
                          {desc} {services?.privacyPolicyLink}
                        </p>
                        <br />
                      </>
                    ))}
                  </>
                </div>
              );
            })}
          </div>
        </div>

        {/* 3 */}
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          {/* <label className="medium">Help Center</label> */}
          <h4 className="medium-head mb-3">
            3. Blockchain Operations & Protocol
          </h4>

          <div>
            {protocol.map((item, index) => {
              return (
                <div className="d-flex flex-column   pb-3">
                  <p className="body-large mb-2">
                    <b>
                      {item?.id} {item?.title}
                    </b>
                  </p>

                  <>
                    {item?.description?.map((desc, index) => (
                      <>
                        <p key={index} className="body-large">
                          {desc}
                        </p>
                        <br />
                      </>
                    ))}
                  </>
                </div>
              );
            })}
          </div>
        </div>

        {/* catalyst */}
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">4. The Catalyst Site </h4>
          {fee?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          <b>{itemss?.title}: </b>
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>
              </div>
            );
          })}
        </div>

        {/* creator */}
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">5. Creator NFTs</h4>
          {creator?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>
                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        {/* ccata */}
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3"> 6. Creators on The Catalyst</h4>
          {creators?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>
                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        {/* property */}
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">
            7. Intellectual Property Disputes
          </h4>
          {disputes?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          {itemss?.title && <b>{itemss?.title}: </b>}
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {items?.conclusion?.map((cc, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {cc}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        {/* limitation */}
        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">
            8. Limitation of Liability & Monetary Cap
          </h4>
          {limitation?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          {itemss?.title && <b>{itemss?.title}: </b>}
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {items?.conclusion?.map((cc, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {cc}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">
            9. Dispute Resolution, Arbitration & Class Action Waiver{" "}
          </h4>
          {dispute?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          {itemss?.title && <b>{itemss?.title}: </b>}
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {items?.conclusion?.map((cc, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {cc}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">10. Survival of Terms</h4>
          {survival?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          {itemss?.title && <b>{itemss?.title}: </b>}
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {items?.conclusion?.map((cc, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {cc}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">
            11. Termination of Access and Account Suspension
          </h4>
          {termination?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          {itemss?.title && <b>{itemss?.title}: </b>}
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {items?.conclusion?.map((cc, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {cc}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>

        <div className="mx-auto px-3" style={{ maxWidth: "700px" }}>
          <h4 className="medium-head mb-3">12. Miscellaneous Provisions</h4>
          {miscellaneous?.map((items, index) => {
            return (
              <div key={index}>
                <p className="body-large mb-3">
                  <b>
                    {items?.id} {items?.title}
                  </b>
                </p>

                {items?.description?.map((it, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {it}
                    </p>
                  );
                })}
                <div>
                  <ol>
                    {items?.fees?.map((itemss, index) => {
                      return (
                        <li>
                          {itemss?.title && <b>{itemss?.title}: </b>}
                          {itemss?.details}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {items?.conclusion?.map((cc, index) => {
                  return (
                    <p className="body-large mb-3" key={index}>
                      {cc}
                    </p>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Terms;
